import { useEffect, useRef } from 'react';

// Re-runs `refresh` when the browser tab/window regains focus, so a page left
// open picks up changes made elsewhere (another tab, window or device). Focus and
// visibility events often fire together, so calls are throttled.
export default function useRefreshOnFocus(refresh, minIntervalMs = 2000) {
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    let last = Date.now();
    const run = () => {
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - last < minIntervalMs) return;
      last = Date.now();
      refreshRef.current();
    };
    window.addEventListener('focus', run);
    document.addEventListener('visibilitychange', run);
    return () => {
      window.removeEventListener('focus', run);
      document.removeEventListener('visibilitychange', run);
    };
  }, [minIntervalMs]);
}
